// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"SopOverviewTooltip_tooltip__2cfd9","tooltipText":"SopOverviewTooltip_tooltipText__EtKT-","tooltipLineEntry":"SopOverviewTooltip_tooltipLineEntry__1loZT"};